import axios from "../axios";

const api = {
  calculateScenarioPlanning(params, accessToken) {
    const config = {
      params: params,
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get("/scenario-planning", config).then(({ status, data }) => { return { status, data }; });
  },
  getScenarioPlanningParameters(accessToken) {
    const config = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get("/scenario-planning/parameters", config).then(({ data }) => data);
  },
  exportChartData(params, accessToken) {
    const config = {
      params: params,
      responseType: "arraybuffer",
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get("/scenario-planning/export", config).then(({ data }) => {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Carbon Pricing Financial Model.xlsx");
      document.body.appendChild(link);
      link.click();
      return true;
    });
  },
  getDecarbonizationPathways(accessToken) {
    const config = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get("/decarbonization/pathways", config).then(({ data }) => data);
  },
};

export default api;